module.exports = __webpack_public_path__ + "static/media/SEARPENT_animated_150px.39cbaff8.gif";